__webpack_require__.p = "https://matchcenter-api.24media.gr/widget/8fa179136aab0825b6a8/";